import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37bd2d55&"
import script from "./history.component.js?vue&type=script&lang=js&"
export * from "./history.component.js?vue&type=script&lang=js&"
import style0 from "./history.style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports